<template>
  <zm-dialog class="zcm-plan-details" v-model="visible" show-close :fullscreen="isFullscreenDialog">
    <h1 class="zcm-plan-details__title">
      {{ title }}
    </h1>
    <price-list
      class="zcm-plan-details__price-list"
      :showDecimalPoint="is_desktop_reactive"
      :plan-category="planCategory"
      :unit-type="planUnitMap.user"
    />
    <ul class="zcm-plan-details__desc">
      <li v-for="item in descList" :key="item">
        <span>{{ item }}</span>
      </li>
    </ul>
  </zm-dialog>
</template>

<script>
import { isMobile } from '@zoom/billing-responsive'

import { ConfirmComponent } from '@/components/common/service-dialog/confirm';
import PriceList from '@/components/price-list.vue';
import { planUnitMap } from '@/common/product-unit';
import { hideModalDialogCloseButton, showModalDialogCloseButton } from '@/utils/modal-utils';

export default {
  name: 'ZoomCustomAiCompanionPlanDetails',
  mixins: [ConfirmComponent],
  components: {
    PriceList,
  },
  props: {
    title: String,
    planCategory: String,
    planTrackingName: String,
  },
  data() {
    return {
      visible: false,
      planUnitMap,
      descList: [
        this.$t('billing.zoom_custom_ai_companion.features_item1'),
        this.$t('billing.zoom_custom_ai_companion.features_item2'),
        this.$t('billing.zoom_custom_ai_companion.features_item3'),
        this.$t('billing.zoom_custom_ai_companion.features_item4'),
        this.$t('billing.zoom_custom_ai_companion.features_item5'),
        this.$t('billing.zoom_custom_ai_companion.features_item6'),
        this.$t('billing.zoom_custom_ai_companion.features_item7'),
      ],
    };
  },
  computed: {
    isFullscreenDialog() {
      return (this.$context?.is?.modal && !this.$context?.is?.modal2Column) || isMobile;
    },
  },
  watch: {
    /**
     * watch visible and fire event
     * @param {boolean} val visible
     */
    visible(val) {
      this.$tracking.buyInteraction(
        'plan details',
        `${this.planTrackingName} plan details - ${val ? 'impression' : 'exit'}`,
      );

      if (val) {
        hideModalDialogCloseButton();
      } else {
        showModalDialogCloseButton();
      }
    },
  },
};
</script>



<style lang="scss" scoped>
@import '@zoom/billing-responsive/styles/responsive.scss';

@include media(mobile, tablet) {
  :deep(.zcm-plan-details) {
    height: 100%;
  }
}

.zcm-plan-details {
  :deep .zbo-dialog {
    padding: 72px 60px;
    min-width: 576px;
    width: fit-content;
    &__header {
      padding-bottom: 0;
    }
  }
  &__title {
    color: var(--zoom-color-text-stronger-neutral, #2A2B2D);
    font-size: 22px;
    font-weight: 700;
    line-height: 1.5em;
  }

  &__price-list {
    margin-bottom: 4px;
    padding: 8px 0;
    @include media(mobile, tablet) {
      margin-top: 4px;
    }
  }

  &__desc {
    list-style-image: url('../../../../assets/plans/check.svg');
    color: var(--zoom-color-text-stronger-neutral, #2A2B2D);
    font-size: 14px;
    font-weight: 400;
    line-height: 1.5em;
    margin-left: 15px;
    > li {
      margin-bottom: 16px;
      &:last-child {
        margin-bottom: 0;
      }
      span {
        position: relative;
        left: 4px;
      }
    }
  }
}
</style>
